module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/sin-avisos-ub.591b7d16.svg";